import { Grid, Typography,Button  } from "@mui/material"
import { useTranslate } from 'react-redux-multilingual';
const Confdata = window['runConfig']

function DisplayMessage({messageToDisplay, errorPage, messageToDisplayOnButton}) {
    function RedirectToJodoToolbar(){
        window.location.href = `${Confdata.apiUrl}/jodotoolbar/`
    }
    const t = useTranslate();
    return(
        <>
            <Grid container className="disply-message-component-grid">
                <div className="disply-message-component-grid-div">
                <Typography variant="subHeading" >
                    {messageToDisplay}
                </Typography>
                <Typography variant="subHeading" >
               { t('emailexist1')}
                </Typography>
                </div>
                {
                    errorPage === "email-auth-page" &&
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                      <Button variant="customPrimary" onClick={RedirectToJodoToolbar}>
                      {messageToDisplayOnButton}
                      </Button>
                    </div>
                }
            </Grid>
        </>
    )
}

export default DisplayMessage;